import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  DrawerCloseButton,
  Switch,
  Flex,
} from "@chakra-ui/react";
import { DateTime } from "luxon";
import ExpertDataService from "../../services/Expert";
const MonthYearDrawer = ({ isOpen, onClose, data, id ,func}: any) => {
  const currentMonth = DateTime.now();

  const initialMonths = [];
  for (let i = 0; i < 12; i++) {
    const futureMonth = currentMonth.plus({ months: i - 1 });
    const monthString = `${DateTime.fromObject({
      month: futureMonth.month,
    }).toFormat("MMMM")} ${futureMonth.year}`;
    const isEnabled =
      data.find((item: any) => item.text === monthString)?.enabled || false;
    initialMonths.push({
      text: monthString,
      month: DateTime.fromObject({
        month: futureMonth.month,
      }).toFormat("MMMM"),
      year: futureMonth.year,
      enabled: isEnabled,
    });
  }

  const [months, setMonths] = useState(initialMonths);

  const handleToggle = (index: any) => {
    const updatedMonths = [...months];
    const enabled = !updatedMonths[index].enabled;
    updatedMonths[index].enabled = enabled;
    ExpertDataService.updateExpertBillingMonth(id, { ...updatedMonths[index] });
    setMonths(updatedMonths);
  };

  const handleSave = ()=>{
    func();
    onClose();
  }

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="right" >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Month and Year</DrawerHeader>
        <DrawerBody>
          {months.map((item, index) => (
            <Flex key={index} align="center" mb={2}>
              <Box
                as="button"
                p={2}
                mr={4}
                borderWidth="1px"
                borderRadius="md"
                bg="gray.100"
                _hover={{ bg: "gray.200" }}
                _active={{ bg: "gray.300" }}
                cursor="default"
                minWidth="150px"
                textAlign="center"
              >
                {item.text}
              </Box>
              <Switch
                isChecked={item.enabled}
                onChange={() => handleToggle(index)}
              />
            </Flex>
          ))}
        </DrawerBody>
        <DrawerFooter>
          <Button colorScheme="blue" onClick={handleSave}>
            Save
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default MonthYearDrawer;
